export default __webpack_public_path__ + "static/media/img (2).97d27428.jpg";